import { create } from 'zustand';

interface SnackbarState {
  open: boolean;
  message: string | null;
  severity: 'success' | 'neutral' | 'warning' | 'danger';
  showSnackbar: (message: string, severity?: 'success' | 'neutral' | 'warning' | 'danger') => void;
  hideSnackbar: () => void;
}

export const useSnackbarStore = create<SnackbarState>((set) => ({
  open: false,
  message: null,
  severity: 'neutral',
  showSnackbar: (message, severity = 'neutral') => set({ open: true, message, severity }),
  hideSnackbar: () => set({ open: false }),
}));
